export const useAvatar = (name?: string, src?: string | null) => {
  const getColor = (str: string): string => {
    if (!str) return "#1890ff";

    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = hash % 360;
    return `hsl(${hue}, 70%, 60%)`;
  };

  const getInitials = (fullName: string): string => {
    if (!fullName || !fullName.trim()) return "?";

    const names = fullName.trim().split(/\s+/);

    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }

    return (
      names[0].charAt(0) + names[names.length - 1].charAt(0)
    ).toUpperCase();
  };

  const fullName = name || "";
  const initials = getInitials(fullName);
  const backgroundColor = !src ? getColor(fullName) : undefined;

  return {
    src,
    children: !src ? initials : undefined,
    style: backgroundColor ? { backgroundColor } : undefined,
  };
};
